import { components } from 'react-select';
import { cx } from '@emotion/css';
import styles from '../dropdown.module.scss';

export const DropdownIndicator = (showDropdownIndicator: boolean) => (props) => {
  return showDropdownIndicator ? (
    <components.DropdownIndicator {...props} className="h-[3rem]">
      <svg
        className={cx('mr-1 w-3 transform transition-transform duration-200', props.selectProps.menuIsOpen ? '-rotate-180' : 'rotate-0')}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
      >
        <polygon
          fill={props.isDisabled ? styles.secondaryDefault : styles.primaryGray}
          points="8.01,13.06 0.02,5.07 1.43,3.65 8.01,10.23 14.58,3.65 16,5.07 "
        />
      </svg>
    </components.DropdownIndicator>
  ) : null;
};
